var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorBoundaryIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 133,
    viewBox: "0 0 172 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6797 39.5337L97.455 91.6711C89.9185 98.1465 81.114 105.094 71.503 112.055C61.8921 119.016 52.549 125.221 44.0496 130.364L6.27427 78.2269C-4.41105 63.4776 -1.11631 42.863 13.6304 32.1776C21.0051 26.835 29.8441 24.986 38.1764 26.3177C46.5114 27.6467 54.337 32.1591 59.6797 39.5337Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1426 64.4376C53.3196 64.4376 56.7056 61.0515 56.7056 56.8745C56.7056 52.6976 53.3196 49.3115 49.1426 49.3115C44.9657 49.3115 41.5796 52.6976 41.5796 56.8745C41.5796 61.0515 44.9657 64.4376 49.1426 64.4376Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0371 81.1788C30.2141 81.1788 33.6002 77.7927 33.6002 73.6158C33.6002 69.4388 30.2141 66.0527 26.0371 66.0527C21.8602 66.0527 18.4741 69.4388 18.4741 73.6158C18.4741 77.7927 21.8602 81.1788 26.0371 81.1788Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1801 60.0233C53.3507 60.0233 54.2997 59.0743 54.2997 57.9037C54.2997 56.7331 53.3507 55.7842 52.1801 55.7842C51.0095 55.7842 50.0605 56.7331 50.0605 57.9037C50.0605 59.0743 51.0095 60.0233 52.1801 60.0233Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0771 76.7645C30.2477 76.7645 31.1966 75.8156 31.1966 74.645C31.1966 73.4744 30.2477 72.5254 29.0771 72.5254C27.9065 72.5254 26.9575 73.4744 26.9575 74.645C26.9575 75.8156 27.9065 76.7645 29.0771 76.7645Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.822 123.531H39.1255L47.3384 98.7941L52.445 83.3975L54.3205 77.7471L63.5176 50.0364L70.5024 28.9894L79.0204 3.32922C79.6782 1.3423 81.5378 0 83.6335 0H103.312C105.41 0 107.27 1.3423 107.927 3.33187L116.446 28.992L123.43 50.039L132.627 77.7498L134.503 83.4002L139.609 98.7968L147.822 123.534V123.531Z",
    fill: "#FFCC00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.172 132.333H19.7764C17.3465 132.333 15.3755 130.362 15.3755 127.932C15.3755 125.502 17.3465 123.531 19.7764 123.531H167.172C169.602 123.531 171.573 125.502 171.573 127.932C171.573 130.362 169.602 132.333 167.172 132.333Z",
    fill: "#FF9900"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.43 50.0363H63.5176L70.5023 28.9893H116.445L123.43 50.0363Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.612 98.7941H47.3359L54.3207 77.7471H132.628L139.612 98.7941Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBoundaryIllustration);
export default __webpack_public_path__ + "static/media/ErrorBoundaryIllustration.561b957c5d7291f797ed58f3d93e9325.svg";
export { ForwardRef as ReactComponent };